// src/routes/dispatchDetailsRoute.js
import DispatchDetails from '../pages/Dashboard/DispatchDetails';

export const dispatchDetailsRoute = {
  path: '/dispatch-details',
  element: <DispatchDetails />   // no protection, no layout
};